<template>

    <div class="header-container-all">


        <div class="header-container">

            <img
                v-if="back"
                class="blue-icon"
                src="/img/icons/arrow-blue.svg"
                @click="clickBack">
            <img
                v-if="close && !isDesktop"
                class="blue-icon"
                src="/img/icons/cancel-blue.svg"
                @click="goToLanding">

            <img
                v-if="share && !isDesktop"
                class="blue-icon blue-icon-right"
                src="/img/icons/share-blue.svg"
                @click="clickShare">

            <img
                v-if="blueCleanfox && isDesktop"
                class="cleanfox-blue pointer"
                src="/img/header/cleanfox-blue.svg"
                @click="goToLanding">

            <img
                v-if="logoCleanfox"
                class="cleanfox-logo pointer"
                src="/img/header/cleanfox-logo-large-white.svg"
                @click="goToLanding">


            <span v-if="showTitle" class="title-baseSemibold">
                    {{ title }}
                </span>

            <span v-if="back && isDesktop"
                  class="back-text pointer noselect"
                  @click="clickBack">
                    {{ $t('global_back') | capitalizeFirstLetter }}
                </span>

            <span v-if="myactions" :class="{ 'green-border-on': myactionstuto }" class="blue-icon blue-icon-right green-border-off">

                <i class=" material-icons md-blue"
                   @click="openMyActions">history</i>

            </span>

            <div v-if="myactionstuto" class="history-tuto-container">

                <div class="tuto-grey-arrow"></div>

                <p class="cf-text">Retrouvez les actions effectuées sur vos newsletters sur la page Mes actions.</p>

                <button class="btn btn-big btn-green btn-history" @click="closeMyActionsTuto">J'ai compris</button>

            </div>

        </div>

        <div v-if="border" class="border"></div>

    </div>

</template>

<script>

import Tag from '@/modules/tag'

export default {

    name: 'header-band',

    computed: {

        showTitle: function () {

            return this.blueCleanfox ? !this.isDesktop : true
        }
    },

    props: {

        title: {
            type: String,
            default: ''
        },

        myactions: {
            type: Boolean,
            default: false
        },

        myactionstuto: {
            type: Boolean,
            default: false
        },

        // only on login desktop process
        close: {
            type: Boolean,
            default: false
        },

        back: {
            type: Boolean,
            default: false
        },

        share: {
            type: Boolean,
            default: false
        },

        blueCleanfox: {
            type: Boolean,
            default: false
        },

        logoCleanfox: {
            type: Boolean,
            default: false
        },

        border: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            showMenu: false
        }
    },

    methods: {

        clickBack() {
            this.$emit('eventBack')
        },

        clickShare() {
            Tag.clickAmplitude(this, 'sharing_top')
            this.$emit('eventShare')
        },

        openMyActions() {
            Tag.clickAmplitude(this, 'myactions') // todo: change event name
            this.$router.push({path: '/my-actions'})
        },

        goToLanding() {
            this.$router.push({path: '/'})
        },

        closeMyActionsTuto() {

            this.$emit('closeMyActionsTuto')

        }
    }

}

</script>

<style lang="scss" scoped>

.header-container-all {
    width: 100%;
}

.header-container {
    width: 100%;
    height: 48px;
    background-color: #ffffff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        height: 72px;
    }
}

.blue-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    position: absolute;
    cursor: pointer;
    left: 16px;

    &:lang(ar-sa) {
        left: unset;
        right: 16px;
        transform: rotate(180deg);
    }
}


.blue-icon-right {
    right: 16px;
    left: auto;
}

.cleanfox-blue {
    width: 107px;
    object-fit: contain;
}

.cleanfox-logo {
    height: 32px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {
        height: 48px;
    }
}

.back-text {
    position: absolute;
    left: 38px;
    padding-left: 8px;
    font-size: 17px;
    font-weight: 600;
    line-height: 1.41;
    color: $aquamarine;

    &:lang(ar-sa) {
        left: unset;
        right: 38px;
    }
}

.green-border-off {
    border-radius: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
}

.green-border-on {
    border: 2px solid $green;
}

.history-tuto-container {
    width: 279px;
    background-color: $midnight;
    color: $white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 1;
    padding: 16px;
    border-radius: 5px;
    top: 48px;
    right: 11px;
    text-align: start;
}

.tuto-grey-arrow {
    background-color: tan;
    position: absolute;
    background-color: $midnight;
    top: -4px;
    right: 10px;
    transform: rotate(45deg);
    width: 10px;
    height: 10px;
}

.btn-history {
    margin-top: 16px;
}


</style>
